// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__PLLTC","col":"styles_col__1IezM","fulfillmentStatus":"styles_fulfillmentStatus__3ZtvV","emailCol":"styles_emailCol__KHk2c"};